import React, { lazy, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Container, CssBaseline, alpha, useTheme, Typography } from '@mui/material';

// Critical CSS inlined
import '../innerComponent/styles/navbarmenu.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NavbarSearch from '../innerComponent/NavbarSearch';

// Lazy load components
const MobileHeader = lazy(() => import('../mobileLayout/mobileHeader'));
const FooterReserved = lazy(() => import('../innerComponent/FooterReserved'));
const MobileFooter = lazy(() => import('../mobileLayout/mobileFooter'));
const ScrollToTop = lazy(() => import('../../components/other/ScrollToTop'));

const MobileRootLayout = React.memo(() => {
  const theme = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <React.Fragment>
      <CssBaseline enableColorScheme />
      <ScrollToTop />

      <Container
        maxWidth={'false'}
        disableGutters
        sx={{
          maxWidth: '100%',
          minHeight: '100vh',
          backgroundColor: alpha(theme.palette.secondary.main, 0.05),
        }}
      >
        {/* Header Section */}
        <MobileHeader />

        {/* Main Content Section */}
        <Container
          maxWidth="md"
          sx={{
            minHeight: "100vh",
            position: 'relative',
            overflow: 'hidden',
            justifyContent: "flex-start"
          }}
        >
          <Box
            sx={{
              height: { xs: 60, sm: 75 },
            }}
          />
          {isHomePage && (
            <Box
              sx={{
                display: {
                  xs: "block",
                  md: "none",
                },
                width: "100%",
                mt: { xs: 0, sm: 2 },
                pb: 1,
              }}
            >
              <NavbarSearch />
            </Box>
          )}

          <Suspense fallback={
            <Box sx={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2
            }}>
              <Box sx={{
                width: 40,
                height: 40,
                border: '3px solid #f3f3f3',
                borderTop: '3px solid #3498db',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
              }} />
              <Typography>Loading...</Typography>
            </Box>
          }>
            <Outlet />
          </Suspense>
        </Container>

        {/* Footer Section */}
        <MobileFooter />
        <FooterReserved />
      </Container>
    </React.Fragment>
  );
});

MobileRootLayout.displayName = 'Layout';

export default MobileRootLayout
